import React, { useContext } from 'react';
import Textarea from '../../../../components/Textarea';
import GlobalContext from '../../../../utils/GlobalContext';

const AssumptionBlock = (props) => {
  const { isEditable, handleChange, text, textStyle, textColor } = props;
  const { locales } = useContext(GlobalContext);

  return (
    <div className="left">
      <div className="block">
        <div
          className={`title ${textStyle} custom-font-body`}
          style={{ color: textColor }}
        >
          {locales.testing.testCard.assumption}
        </div>
        <div className="content is-full-width">
          {isEditable ? (
            <Textarea
              onChange={handleChange}
              name="assumption.text"
              delay={700}
              value={text}
              className={`bmc-form-textarea ${textStyle} custom-font-body`}
            />
          ) : (
            <div
              className={`text ${textStyle} custom-font-body`}
              style={{ color: textColor }}
            >
              {text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssumptionBlock;
